/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Ad_PlaceholderInputs */

const en_audio_embed_export_ad_placeholder = /** @type {(inputs: Audio_Embed_Export_Ad_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select an audio file...`)
};

const fr_audio_embed_export_ad_placeholder = /** @type {(inputs: Audio_Embed_Export_Ad_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez un fichier audio...`)
};

const de_audio_embed_export_ad_placeholder = /** @type {(inputs: Audio_Embed_Export_Ad_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eine Audiodatei aus...`)
};

const it_audio_embed_export_ad_placeholder = /** @type {(inputs: Audio_Embed_Export_Ad_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un file audio...`)
};

const ru_audio_embed_export_ad_placeholder = /** @type {(inputs: Audio_Embed_Export_Ad_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите аудиофайл...`)
};

const es_audio_embed_export_ad_placeholder = /** @type {(inputs: Audio_Embed_Export_Ad_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un archivo de audio...`)
};

const zh_cn2_audio_embed_export_ad_placeholder = /** @type {(inputs: Audio_Embed_Export_Ad_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择一个音频文件……`)
};

const ja_audio_embed_export_ad_placeholder = /** @type {(inputs: Audio_Embed_Export_Ad_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声ファイルを選択してください...`)
};

const hi_audio_embed_export_ad_placeholder = /** @type {(inputs: Audio_Embed_Export_Ad_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक ऑडियो फ़ाइल चुनें...`)
};

const pt_pt2_audio_embed_export_ad_placeholder = /** @type {(inputs: Audio_Embed_Export_Ad_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um arquivo de áudio...`)
};

/**
* | output |
* | --- |
* | "Select an audio file..." |
*
* @param {Audio_Embed_Export_Ad_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_ad_placeholder = /** @type {((inputs?: Audio_Embed_Export_Ad_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Ad_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_ad_placeholder(inputs)
	if (locale === "de") return de_audio_embed_export_ad_placeholder(inputs)
	if (locale === "it") return it_audio_embed_export_ad_placeholder(inputs)
	if (locale === "ru") return ru_audio_embed_export_ad_placeholder(inputs)
	if (locale === "es") return es_audio_embed_export_ad_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_ad_placeholder(inputs)
	if (locale === "ja") return ja_audio_embed_export_ad_placeholder(inputs)
	if (locale === "hi") return hi_audio_embed_export_ad_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_ad_placeholder(inputs)
	return en_audio_embed_export_ad_placeholder(inputs)
});